import moment from 'moment';

import formatCurrency from 'Helper/formatCurrency';
import formatNumber from 'Helper/formatNumber';

const getReportHostSummaryResponse = (response) => {
  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const isDataExist = response?.isDataExist;
  const lastSync = response?.lastSync ? moment(response?.lastSync).format('DD MMMM YYYY, HH:mm:ss') : '-';

  const reports = response?.data?.map((item) => {
    const id = item?.id;

    return {
      id,
      host: {
        name: item?.hostName,
        brand: item?.brandName,
      },
      targetGmv: formatCurrency(item?.targetGmv || 0),
      actualGmv: formatCurrency(item?.actualGmv || 0),
      achievementGmvPercentage: `${formatNumber(item?.achievementGmvPercentage || 0, 1)}%`,
      targetErr: `${formatNumber(item?.targetErr || 0, 1)}%`,
      actualErr: `${formatNumber(item?.actualErr || 0, 1)}%`,
      achievementErrPercentage: `${formatNumber(item?.achievementErrPercentage || 0, 1)}%`,
      targetCtr: `${formatNumber(item?.targetCtr || 0, 1)}%`,
      actualCtr: `${formatNumber(item?.actualCtr || 0, 1)}%`,
      achievementCtrPercentage: `${formatNumber(item?.achievementCtrPercentage || 0, 1)}%`,
      targetCtor: `${formatNumber(item?.targetCtor || 0, 1)}%`,
      actualCtor: `${formatNumber(item?.actualCtor || 0, 1)}%`,
      achievementCtorPercentage: `${formatNumber(item?.achievementCtorPercentage || 0, 1)}%`,
      targetAov: formatCurrency(item?.targetAov || 0),
      actualAov: formatCurrency(item?.actualAov || 0),
      achievementAovPercentage: `${formatNumber(item?.achievementAovPercentage || 0, 1)}%`,
      actualAwd: item?.actualAwd,
      targetViews: formatNumber(item?.targetViews || 0, 1),
      actualViews: formatNumber(item?.actualViews || 0, 1),
      achievementViewsPercentage: `${formatNumber(item?.achievementViewsPercentage || 0, 1)}%`,
      rawData: item,
    };
  });

  return { reports, totalData, totalPage, isDataExist, lastSync };
};

export default getReportHostSummaryResponse;
